import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export function useReviewDiscrepancy() {
  return useMutation({
    mutationFn: async ({
      discrepancyId,
      selectedGroundTruthId,
    }: {
      discrepancyId: string
      selectedGroundTruthId: string | null
    }): Promise<void> => {
      await apiClient.post(`/int/v2/audit/review/${discrepancyId}`, {
        selectedGroundTruthId,
      })
    },
  })
}
